import { Avatar, Typography, useTheme } from "@mui/material";
import { styled } from "@mui/system";
import { OverridableStringUnion } from "@mui/types";
import useCurrency from "helpers/useCurrency";

export type Variant =
  | "h1"
  | "h2"
  | "h3"
  | "h4"
  | "h5"
  | "h6"
  | "subtitle1"
  | "subtitle2"
  | "body1"
  | "body2"
  | "caption"
  | "button"
  | "overline";

export interface TypographyPropsVariantOverrides {}

export const RawBox = styled("div")(({ theme }) => ({
  backgroundColor: "white",
  borderRadius: theme.shape.borderRadius,
}));
export const BoxBodyContainer = styled("div")(({ theme }) => ({
  padding: "15px 24px",
  minHeight: "350px",
}));

export const FlexBox = styled("div")({
  display: "flex",
  alignItems: "center",
});

export const StyledAvatar = styled(Avatar)(
  ({ theme, outLine = true }: { theme?: ThemeObjType; outLine?: boolean }) => ({
    width: "100%",
    height: "100%",
    borderRadius: theme?.shape.borderRadius || "none",
    // border: outLine ? `2px solid ${theme?.palette.disabled.main || 'none'}` : 'none'
    border: outLine ? `2px solid ${theme?.palette.disabled.light || "none"}` : "none",
  })
);

export const TagSection = styled(Typography)(({ theme }) => ({
  // display: 'flex',
  // flexDirection: 'column',
  backgroundColor: theme.palette.primary.light,
  borderRadius: theme.shape.borderRadius,
  minWidth: "24px",
  padding: "5px 10px",
  whiteSpace: "nowrap",
}));

export const PriceComponent = ({
  color,
  price,
  isBold,
  variant,
  currency,
}: {
  color?: string;
  price?: string;
  isBold?: boolean;
  variant?: OverridableStringUnion<Variant | "inherit", TypographyPropsVariantOverrides>;
  currency?: string;
}) => {
  const theme = useTheme();
  const { defCur } = useCurrency();
  return (
    <FlexBox>
      <Typography fontWeight={isBold ? "bold" : "none"} variant={variant || "body1"} color={color}>
        {price}
      </Typography>
      {(currency || defCur) && (
        <Typography variant="body2" color={theme.palette.disabled.main}>
          &nbsp;
          {currency || defCur.en_title}
        </Typography>
      )}
    </FlexBox>
  );
};
